// extracted by mini-css-extract-plugin
export default {"chipsFilterContainer":"ChipsFilter_chipsFilterContainer__-r8du","mappedChips":"ChipsFilter_mappedChips__khUyq","chip":"ChipsFilter_chip__5hh8+"};